module.exports = __webpack_public_path__ + "static/media/quansic.ba50103c.png";